import React from 'react';
import { usePermissions } from '../../auth/PermissionsContext';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import ContactsTable from '../../components/contacts/ContactsTable';
import Forbidden from '../Forbidden';

const Contacts = () => {
    const { has } = usePermissions();

    if (!has('viewAny-contact')) {
        return <Forbidden />;
    }

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <ContactsTable />
        </WrapperSection>
    );
};

export default Contacts;
